module.exports = __webpack_public_path__ + "img/icon_map_car.09ba9b0a.png";